import APIRequest from './APIRequest';

export const GetContactTypes = () =>
  APIRequest({
    url: 'Contact/ContactTypes',
    method: 'get'
  })